import React, { Suspense } from "react";
import { SecureRoute } from "@okta/okta-react";

import routes from "@/v1/config/routes";
import { useUserStore } from "@/v2/store/useUserStore";
import { canAccessRoute } from "@/v2/utils/canAccessRoute";

const Router = () => {
  const userPermissions = useUserStore((state) => state.activePermissions);
  const isOwner = useUserStore((state) => state.isOwner);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {routes
        .filter((route) => canAccessRoute(route, { permissions: userPermissions, isOwner }))
        .map((route) => (
          <SecureRoute key={route.path} {...route} />
        ))}
    </Suspense>
  );
};

export default Router;
